import { Component, OnInit, OnChanges, SimpleChanges, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../../api.service';
import { CommonService } from "../../shared/common.service";

@Component({
  selector: 'app-edit-user',
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.scss']
})
export class EditUserComponent implements OnInit, OnChanges {
  @Input() userId: string = '';
  @Output() userUpdatedEvent = new EventEmitter<void>();
  @Output() closeFormEvent = new EventEmitter<void>();

  userForm: FormGroup;
  designations: string[] = [];
  emailError: string | null = null;
  message: string;


  constructor(
    private fb: FormBuilder,
    private apiService: ApiService,
    private commonService: CommonService
  ) {
    // Initialize the form as early as possible so template bindings
    // and ngOnChanges can safely access it.
    this.initializeForm();
  }

  ngOnInit(): void {
    let userData = this.commonService.getUserData(); 

    if (userData == null) { // Check if user data is null
      this.commonService.logout(); // Call logout method
    }

    this.loadDesignations();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['userId'] && this.userId) {
      this.loadUserData();
    }
  }
  get f() {
    return this.userForm.controls;
  }

  private initializeForm(): void {
    this.userForm = this.fb.group({
      first_name: ['', Validators.required],
      last_name: ['', Validators.required],
      mobile: ['', [Validators.required, Validators.pattern('^[0-9]{10}$')]],
      email: ['', [Validators.required, Validators.email]],
      designation: ['', Validators.required],
      // site_location: ['', Validators.required],
      // site_city: ['', Validators.required],
      // site_state: ['', Validators.required],
      role: ['']
    });
  }
  

  private loadUserData(): void {
    if (!this.userId) {
      return;
    }

    this.apiService.getEditUserById(this.userId).subscribe(
      (response) => {
        // Some APIs wrap the user object (e.g. { data: {...} }); handle both shapes.
        const userData: any = (response && response.data) ? response.data : response;

        if (userData) {
          this.userForm.patchValue({
            first_name: userData.first_name || '',
            last_name: userData.last_name || '',
            mobile: userData.mobile || '',
            email: userData.email || '',
            designation: userData.designation || '',
            role: userData.role || ''
          });

          // Disable email field to prevent changes during update
          this.userForm.get('email')?.disable();
        } else {
          alert('User not found.');
        }
      },
      () => {
        alert('Failed to load user data. Please try again later.');
      }
    );
  }

  private loadDesignations(): void {
    this.apiService.getDesignations().subscribe(response => {
      this.designations = response.map((item: any) => item.designation);
    });
  }

  // private loadCities(): void {
  //   this.apiService.getCities().subscribe(response => {
  //     this.cities = response.map((item: any) => item.city);
  //   });
  // }

  // private loadSiteLocations(): void {
  //   this.apiService.getSiteLocations().subscribe(response => {
  //     this.siteLocations = response.map((item: any) => item.site_location);
  //   });
  // }

  // private loadStates(): void {
  //   this.apiService.getStates().subscribe(response => {
  //     this.states = response.map((item: any) => item.state);
  //   });
  // }

  onSubmit(): void {
    if (this.userForm.valid) {
      console.log('Submitted user data:'); // Log form data
      // Use getRawValue() to include disabled fields (like email)
      this.apiService.updateUser(this.userId, this.userForm.getRawValue()).subscribe(
        (response) => {
          alert('Update successful'); // Show success message
          this.userUpdatedEvent.emit();
          this.closeFormEvent.emit();
        },
        error => {
          this.emailError = null;
          
          
          if (error.error && typeof error.error === 'object' && error.error.message) {
            this.emailError = error.error.message; // Use backend error message
          } else if (error instanceof Error) {
            this.emailError = error.message;
          } else if (typeof error === 'string') {
            this.emailError = error;
          } else {
            this.emailError = 'An unexpected error occurred';
          }
          
          this.message="email exits please use another email";
          console.log('', this.message);
          
          alert(this.message); // Alert the user about the error
        }
      );
      
    } else {
      alert('Please fill all required fields.');
    }
  }
  
  

  onCancel(): void {
    this.closeFormEvent.emit();
  }
  



}